export var toggleRadioOff = [
    'M7.81 2C4.6 2 2 4.6 2 7.81C2 11.02 4.6 13.63 7.81 13.63C11.02 13.63 13.63 11.02 13.63 7.81C13.63 4.6 11.02 2 7.81 2ZM12.88 7.81C12.88 10.6 10.6 12.88 7.81 12.88C5.02 12.88 2.75 10.63 2.75 7.81C2.75 5.05 5 2.75 7.81 2.75C10.58 2.75 12.88 5.02 12.88 7.81Z',
];
